import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import {
	Avatar,
	Button,
	CssBaseline,
	TextField,
	FormControl,
	FormControlLabel,
	Checkbox,
	FormHelperText,
	Grid,
	Box,
	Typography,
	Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styled from 'styled-components';

// mui의 css 우선순위가 높기때문에 important를 설정 - 실무하다 보면 종종 발생 우선순위 문제
const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
`;

const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`;

const Login = () => {
	const navigate = useNavigate();
	const theme = createTheme();
	const [idError, setIdError] = useState('');
	const [passwordState, setPasswordState] = useState('');
	const [registerError, setRegisterError] = useState('');

	const setStorage = (key, value, expiry = 0) => {
		if (expiry === 0) return;
		localStorage.setItem(key, value);
		localStorage.setItem('expiry', expiry);
	};

	const onhandlePost = async (data) => {
		const { memberId, password } = data;
		const postData = qs.stringify({
			user_id: memberId,
			user_pw: password,
		});

		// post
		await axios
			.post(`${window.location.protocol}//${window.location.hostname}:3001/login`, postData)
			.then(function (res) {
				if (res.data.success) {
					console.log('로그인 성공 토큰', res.data.token);
					setStorage('token', res.data.token, 3600000 * 3);
					navigate('/proc');
				} else {
					setRegisterError('로그인에 실패하였습니다. 다시한번 확인해 주세요.');
				}
			})
			.catch(function (err) {
				console.log(err);
				setRegisterError('로그인에 실패하였습니다. 다시한번 확인해 주세요.');
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const data = new FormData(e.currentTarget);
		const joinData = {
			memberId: data.get('memberId'),
			password: data.get('password'),
		};
		const { memberId, password } = joinData;

		// 이메일 유효성 체크
		// const idRegex = /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
		// if (!idRegex.test(memberId)) setIdError('올바른 아이디 형식이 아닙니다.');
		// else setIdError('');

		// 비밀번호 유효성 체크
		const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,25}$/; // /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
		if (!passwordRegex.test(password))
			setPasswordState('숫자+영문자 조합으로 8자리 이상 입력해주세요!');
		else setPasswordState('');

		if (
			//   idRegex.test(memberId) &&
			passwordRegex.test(password)
		) {
			onhandlePost(joinData);
		}
	};
	// 페이지 렌더링 후 가장 처음 호출되는 함수
	useEffect(
		() => {
			axios
				.post(
					`${window.location.protocol}//${window.location.hostname}:3001/check`,
					qs.stringify({
						token: localStorage.getItem('token'),
					})
				)
				.then((res) => {
					if (res.data.expired) localStorage.removeItem('token');
					else if (localStorage.getItem('token')) navigate('/proc');
				})
				.catch();
		},
		// 페이지 호출 후 처음 한번만 호출될 수 있도록 [] 추가
		[]
	);

	return (
		<ThemeProvider theme={theme}>
			<Container component='main' maxWidth='xs'>
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Avatar sx={{ m: 1, bgcolor: 'secondary.main' }} />
					<Typography component='h1' variant='h5'>
						로그인
					</Typography>
					<Boxs component='form' noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
						<FormControl component='fieldset' variant='standard'>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										required
										autoFocus
										fullWidth
										type='email'
										id='memberId'
										name='memberId'
										label='아이디'
										error={idError !== '' || false}
									/>
								</Grid>
								<FormHelperTexts>{idError}</FormHelperTexts>
								<Grid item xs={12}>
									<TextField
										required
										fullWidth
										type='password'
										id='password'
										name='password'
										label='비밀번호 (숫자+영문자 8자리 이상)'
										error={passwordState !== '' || false}
									/>
								</Grid>
							</Grid>
							<Button
								type='submit'
								fullWidth
								variant='contained'
								sx={{ mt: 3, mb: 2 }}
								size='large'
							>
								로그인
							</Button>
						</FormControl>
						<FormHelperTexts>{registerError}</FormHelperTexts>
					</Boxs>
				</Box>
			</Container>
		</ThemeProvider>
	);
};

export default Login;
